import { isAdfDocEmpty } from './admin-controls/utils/isAdfDocEmpty.ts';
import { parseAdfString } from './admin-controls/utils/parseAdfString.ts';

/**
 * `AccessDisabledMessage` handles its own fallback, so this is only for screens that must pick a
 * title or illustration on that basis before rendering.
 */
export const hasCustomAccessMessage = (messageContent: string | null | undefined): boolean => {
	const adfDoc = parseAdfString(messageContent);

	return Boolean(adfDoc) && !isAdfDocEmpty(adfDoc);
};
